interface SectionLabelProps {
  children: React.ReactNode;
  align?: 'left' | 'center';
  light?: boolean;
}

export default function SectionLabel({ children, align = 'left', light = false }: SectionLabelProps) {
  const alignment = align === 'center' ? 'justify-center text-center' : 'justify-start text-left';
  return (
    <p
      className={`flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.28em] ${
        light ? 'text-accent-300' : 'text-primary-500'
      } ${alignment}`}
    >
      <span className={`h-px w-8 ${light ? 'bg-accent-300/60' : 'bg-primary-500/50'}`} aria-hidden="true" />
      {children}
    </p>
  );
}